import React, { useContext } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form, Button, Header } from 'semantic-ui-react';
import TextInput from '../../app/common/form/TextInput';
import { RootStoreContext } from '../../app/stores/rootStore';
import { ILoginRequest, IResetPasswordRequest } from '../../app/models/shareholder';
import { FORM_ERROR } from 'final-form';
import { combineValidators, isRequired, createValidator, composeValidators, matchesField, hasLengthGreaterThan } from 'revalidate';
import ErrorMessage from '../../app/common/form/ErrorMessage';
import { observer } from 'mobx-react-lite';

const isValidEmail = createValidator(
  message => value => {
    if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      return message
    }
  },
  'Invalid email address'
)

const validate = combineValidators({
  email: composeValidators(
    isRequired('Email'),
    isValidEmail
  )(),
  password: composeValidators(
    isRequired({ message: 'Required' }),

    hasLengthGreaterThan(6)({
      message: 'Password must be atleast 7 characters'
    })
  )(),
  password_confirmation: matchesField('password', 'Confirm Password')({
    message: 'Passwords do not match',
  }),
});

interface IProps {
  email: string,
  token: string,
}

const ResetPasswordForm: React.FC<IProps> = ({email, token}) => {
  const rootStore = useContext(RootStoreContext);
  const { reset, errorMessage } = rootStore.shareholderStore;
  return (
    <FinalForm
      onSubmit={(values: IResetPasswordRequest) =>
        reset(values).catch(error => ({
          [FORM_ERROR]: error
        }))
      }
      initialValues={{ email: email, password: '', token: token, password_confirmation: '' }}
      validate={validate}
      render={({
        handleSubmit,
        submitting,
        submitError,
        invalid,
        pristine,
        dirtySinceLastSubmit
      }) => (
        <Form onSubmit={handleSubmit} error className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <Header
            as='h2'
            content='Share Register Reset Password'
            color='blue'
            textAlign='center'
          />
          <Field name='email' component={TextInput} value={email} placeholder='Email' />
          <Field name='password' component={TextInput} placeholder='Password' type='password' />
          <Field name='password_confirmation' component={TextInput} placeholder='Confirm Password' type='password' />
          {submitError && !dirtySinceLastSubmit && (
            <ErrorMessage
              text={errorMessage}
              error={submitError}
            />
          )}
          <Button
            disabled={(invalid && !dirtySinceLastSubmit) || pristine}
            loading={submitting}
            primary
            content='Login'
            fluid
          />
        </Form>
      )}
    />
  );
};

export default observer(ResetPasswordForm);
